import React from "react";
import { SiteHeader, SiteFooter } from "../SiteChrome";

export const EditionShell = ({ title, eyebrow, children, actions, activeNav = "Today", testId = "edition-page", ticker = false, theme }) => <div className={`${theme === "lens" ? "lens-theme " : ""}min-h-screen bg-[var(--paper)] text-[var(--ink)]`} data-testid={testId} data-theme={theme}>
  <SiteHeader activeNav={activeNav} ticker={ticker} />
  <main className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-10 pt-4 md:pt-8 pb-10 min-w-0">
    <header className="flex flex-wrap justify-between items-center gap-3 mb-4 md:mb-6">
      <div className="min-w-0">{eyebrow && <div className="text-[10px] text-[var(--muted)] uppercase mb-1" data-testid={`${testId}-eyebrow`}>{eyebrow}</div>}<h1 className="font-serif text-4xl sm:text-5xl leading-tight break-words" data-testid={`${testId}-title`}>{title}</h1></div>
      {actions && <div className="flex flex-wrap items-center gap-2 max-w-full" data-testid={`${testId}-actions`}>{actions}</div>}
    </header>
    {children}
  </main>
  <SiteFooter />
</div>;